import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Injectable, ElementRef } from '@angular/core';
import { NotificationsService } from 'src/app/shared/services/notifications.service';
import 'rxjs/add/operator/do'
import { LoaderService } from '../services/loader.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  constructor(
    public _notificationService: NotificationsService,
    private _loaderService: LoaderService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this._loaderService.activeLoader(request.url);
    return next.handle(request)
      .pipe(
        retry(1),
        catchError((error: HttpErrorResponse) => {
          this._loaderService.deactiveLoader(request.url);
          const errorMessage: any = this.createErrorMessage(error)
          const errorMessageNode: any = this.createNodedataErrorMessage(error)

          if (typeof errorMessage === "string") {
            this._notificationService.error('Error', errorMessage);
          }
          else if (typeof errorMessageNode === "string") {

            this._notificationService.error('Error', errorMessageNode);
            return throwError(errorMessageNode);
          }
          else {
            const nodeErrorMessage: any = this.createNodeErrorMessage(error);
            if (typeof nodeErrorMessage === "string") {
              this._notificationService.error('Error', nodeErrorMessage);
              return throwError(nodeErrorMessage);
            }

            this._notificationService.error('Error', errorMessage.userMessage);
          }
          return throwError(errorMessage);
        })
      )
      .do(event => {
        if (event instanceof HttpResponse) {
          this._loaderService.deactiveLoader(request.url);
        }
      })

  }

  private createErrorMessage(error: HttpErrorResponse): string {
    const errorContentDef = "There was an error. Please contact support desk.";
    const errorContent = error.error?.Message || error.error?.userMessage || error.error;
    const isHtmlErrorMessage = this.isHtmlError(errorContent);

    if (isHtmlErrorMessage) {
      return errorContentDef;
    }

    return errorContent;
  }
  private createNodeErrorMessage(error: HttpErrorResponse): string {
    const errorContentDef = "There was an error. Please contact support desk.";

    if (error.error && typeof error.error === 'object') {
      if (error.error.message) {
        return error.error.errors[0].msg;
      }
      if (error.error.data?.message) {
        return error.error.data.message;
      }
    }

    return errorContentDef;
  }
  private createNodedataErrorMessage(error: HttpErrorResponse): string {
    const errorContentDef = "There was an error. Please contact support desk.";

 
    if (error.error && typeof error.error === 'object') {

      if(error.error.errors && typeof error.error.errors){
        return error.error.errors[0].msg;
      }
      if (error.error.message) {
        return error.error.message; 
      }
      if (error.error.data?.message) {
        return error.error.data.message; 
      } else {
        console.log("error", error)
      }
    }

    return errorContentDef;
  }


  private isHtmlError(errorContent: string) {
    const regexIsHtml = /<html/;
    return regexIsHtml.test(errorContent);
  }
}




